<div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ng-container *ngIf="storageservice.detectMob()">
    <div class="arrow-back-button bg-transparent">
      <span class="icon-container cursor-pointer" (click)="closeDialog()">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </span>
      <span class="text-container">
        <label *ngIf="values?.isEditEvent" class="quicksand-bold-label">Update Event</label>
        <label *ngIf="!values?.isEditEvent" class="quicksand-bold-label">Add Event</label>
      </span>
    </div>
    <nb-card class="card-content">
      <nb-card-body>
        <div class="add-event-form-content">
          <form [formGroup]="addEventsForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label quicksand-bold-label">Event Title <span class="required-field">*</span></label>
                  <input type="text" nbInput fullWidth formControlName="title" placeholder="Enter Title" />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label quicksand-bold-label">Start <span class="required-field">*</span></label>
                  <br />

                  <input
                    nbInput
                    placeholder="Pick Start Date Time"
                    [nbDatepicker]="dateTimePickerStart"
                    formControlName="start"
                    class="w-100 date-inputs"
                  />
                  <nb-date-timepicker
                    #dateTimePickerStart
                    singleColumn
                    [min]="minStartDate ? minStartDate.$d : null"
                    [step]="30"
                    [showNowButton]="false"
                  ></nb-date-timepicker>
                  <!-- Removed [max] because if was urgent but need to check it properly once -->
                   <!-- [max]="schoolEndDate" -->
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label quicksand-bold-label">End <span class="required-field">*</span></label>
                  <br />

                  <input
                    type="text"
                    placeholder="Pick End Date Time"
                    readonly
                    *ngIf="!addEventsForm.value.start"
                    class="w-100 pl-3 end-date-read-only-picker date-inputs"
                    formControlName="end"
                  />

                  <input
                    nbInput
                    placeholder="Pick End Date Time"
                    [nbDatepicker]="dateTimePickerEnd"
                    formControlName="end"
                    class="w-100 date-inputs"
                    [ngModel]="addEventsForm.value.start"
                    *ngIf="addEventsForm.value.start && !values?.isEditEvent"
                  />

                  <input
                    nbInput
                    placeholder="Pick End Date Time"
                    [nbDatepicker]="dateTimePickerEnd"
                    formControlName="end"
                    class="w-100 date-inputs"
                    *ngIf="addEventsForm.value.start && values?.isEditEvent"
                  />

                  <nb-date-timepicker
                    #dateTimePickerEnd
                    singleColumn
                    [step]="30"
                    [min]="minEndDate ? minEndDate : addEventsForm.value.start"
                    [max]="endDate ? endDate : null"
                    [showCurrentTimeButton]="false"
                  ></nb-date-timepicker>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label quicksand-bold-label">Select Users To View</label>

                  <mat-select multiple #sl placeholder="Select Users" formControlName="viewUsers" class="margin-filter-user">
                    <select
                      placeholder="Filter Users By Role"
                      class="filter-user-by-roles m-2 float-right bg-transparent quicksand-bold-label"
                      formControlName="filterUsers"
                      (change)="filterUsersByRole($event)"
                    >
                      <option value="" disabled selected hidden class="placeholder">Filter Users By Role</option>
                      <option value="All" class="placeholder">All</option>
                      <option *ngFor="let role of values?.roles" [value]="role.id">
                        {{ role.name }}
                      </option>
                    </select>
                    <br />
                    <mat-option [value]="'SelectAll'" (click)="selectAllUsers()">Select All</mat-option>

                    <mat-option *ngFor="let user of values?.users" [value]="user.id" (click)="selectUsers()"
                      >{{ user.firstName | titlecase }} {{ user.lastName | titlecase }}</mat-option
                    >
                    <button
                      (click)="sl.close()"
                      mat-raised-button
                      class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
                    >
                      Ok
                    </button>
                  </mat-select>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="d-flex justify-content-end footer-content">
          <button
            nbButton
            class="cancel-add cancel cursor-pointer height: 45px; m-2 w-100 quicksand-bold-label bg-white bg-white-color text-capitalize"
            (click)="
              submitForm.emit(false); addEventsForm.reset(); analyticsService?.trackEvent('Admin School Modal', 'Admin School Events')
            "
          >
            Cancel
          </button>

          <button
            nbButton
            class="cancel-add cursor-pointer m-2 w-100 quicksand-bold-label text-capitalize add-event-button"
            [disabled]="addEventsForm.invalid"
            (click)="addEvent()"
          >
            <span *ngIf="!values?.isEditEvent">Add Event</span>
            <span *ngIf="values?.isEditEvent">Save</span>
          </button>

          <button nbButton class="bg-transparent delete-event m-2" *ngIf="values?.isEditEvent" (click)="deleteEvent(dialog)">
            <img src="/assets/icons/delete.svg" alt="share-icon" class="cursor-pointer" height="20" width="20" />
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </ng-container>

  <ng-container *ngIf="!storageservice.detectMob()">
    <ngx-spinner
      template="<img src='/assets/icons/Respond-spinner.gif' height='150' width='150' class='text-center' loading='lazy'/>"
      [showSpinner]="loading"
      size="small"
      [disableAnimation]="false"
      color="white"
      bdColor="rgba(0,0,0,0.5)"
      [fullScreen]="false"
      [zIndex]="1003"
    >
    </ngx-spinner>
    <div class="add-event-form-content p-3">
      <form [formGroup]="addEventsForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="label form-control-label quicksand-bold-label">Event Title<span class="required-field">*</span></label>
              <input type="text" class="nb-input" nbInput fullWidth formControlName="title" placeholder="Enter Title" maxlength="50" />
              <label
                class="quicksand-bold-label error-label mb-0"
                *ngIf="addEventsForm.controls.title.invalid && (addEventsForm.controls.title.dirty || addEventsForm.controls.title.touched)"
                >Please enter title
              </label>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label class="label form-control-label quicksand-bold-label">Start <span class="required-field">*</span></label>
              <br />

              <input
                nbInput
                placeholder="Pick Start Date Time"
                [nbDatepicker]="dateTimePickerStart"
                formControlName="start"
                class="w-100 date-inputs"
                readonly
              />
              <nb-date-timepicker
                #dateTimePickerStart
                singleColumn
                [min]="minStartDate ? minStartDate.$d : null"
                [step]="30"
                [showCurrentTimeButton]="false"
              ></nb-date-timepicker>
               <!-- Removed [max] because if was urgent but need to check it properly once -->
                   <!-- [max]="schoolEndDate" -->
              <label
                class="quicksand-bold-label error-label mb-0"
                *ngIf="addEventsForm.controls.start.invalid && (addEventsForm.controls.start.dirty || addEventsForm.controls.start.touched)"
                >Please enter start date
              </label>
              <!-- [min]="startDate ? startDate : null" -->
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label class="label form-control-label quicksand-bold-label">End <span class="required-field">*</span></label>
              <br />

              <input
                type="text"
                placeholder="Pick End Date Time"
                readonly
                *ngIf="!addEventsForm.value.start"
                class="w-100 pl-3 end-date-read-only-picker date-inputs"
                formControlName="end"
              />

              <input
                nbInput
                placeholder="Pick End Date Time"
                [nbDatepicker]="dateTimePickerEnd"
                formControlName="end"
                class="w-100 date-inputs"
                [ngModel]="addEventsForm.value.start"
                *ngIf="addEventsForm.value.start && !values?.isEditEvent"
              />

              <input
                nbInput
                placeholder="Pick End Date Time"
                [nbDatepicker]="dateTimePickerEnd"
                formControlName="end"
                class="w-100 date-inputs"
                *ngIf="addEventsForm.value.start && values?.isEditEvent"
              />

              <nb-date-timepicker
                #dateTimePickerEnd
                singleColumn
                [step]="30"
                [min]="minEndDate ? minEndDate : addEventsForm.value.start"
                [max]="endDate ? endDate : null"
                [showCurrentTimeButton]="false"
              ></nb-date-timepicker>

              <label
                class="quicksand-bold-label error-label mb-0"
                *ngIf="
                  addEventsForm.controls['end'].hasError('required') &&
                  (addEventsForm.controls['end'].dirty || addEventsForm.controls['end'].touched)
                "
              >
                Please select an end date to auto-generate the end time.
              </label>

              <label
                class="quicksand-bold-label error-label mb-0"
                *ngIf="
                  addEventsForm.controls['end'].hasError('endDateTimeBeforeStart') &&
                  (addEventsForm.controls['end'].dirty || addEventsForm.controls['end'].touched)
                "
              >
                End date/time must be after the start date/time.
              </label>

              <!-- [min]="addEventsForm?.value?.start" -->
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label class="label form-control-label quicksand-bold-label">Select Users To View</label>

              <mat-select multiple #sl placeholder="Select Users" formControlName="viewUsers" class="margin-filter-user">
                <select
                  placeholder="Filter Users By Role"
                  class="filter-user-by-roles m-2 float-right bg-transparent quicksand-bold-label filter-role-events"
                  formControlName="filterUsers"
                  (change)="filterUsersByRole($event)"
                >
                  <option value="" disabled selected hidden class="placeholder">Filter Users By Role</option>
                  <option value="All" class="placeholder">All</option>
                  <option *ngFor="let role of values?.roles" [value]="role.id">
                    {{ role.name }}
                  </option>
                </select>
                <br />
                <mat-option [value]="'SelectAll'" (click)="selectAllUsers()" [ngClass]="{ 'd-none': values.users.length === 0 }"
                  >Select All</mat-option
                >

                <mat-option *ngFor="let user of values?.users" [value]="user.id" (click)="selectUsers()" class="add-event-mat-option"
                  >{{ user.firstName | titlecase }} {{ user.lastName | titlecase }}</mat-option
                >
                <button
                  (click)="sl.close()"
                  mat-raised-button
                  class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
                >
                  Ok
                </button>
                <div class="quicksand-bold-label ml-3 no-data-found" *ngIf="values?.users?.length === 0">No Users Found!</div>
              </mat-select>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-end footer-content" *ngIf="!isView">
      <button
        nbButton
        class="cancel-add cancel cursor-pointer height: 45px; m-2 w-100 quicksand-bold-label bg-white bg-white-color text-capitalize"
        (click)="submitForm.emit(false); addEventsForm.reset(); analyticsService?.trackEvent('Admin School Modal', 'Admin School Events')"
      >
        Cancel
      </button>

      <button
        nbButton
        class="cancel-add cursor-pointer m-2 w-100 quicksand-bold-label quicksand-bold-label text-capitalize add-event-button"
        [disabled]="addEventsForm.invalid"
        (click)="addEvent()"
      >
        <span *ngIf="!values?.isEditEvent">Add Event</span>
        <span *ngIf="values?.isEditEvent">Save</span>
      </button>

      <button nbButton class="bg-transparent delete-event m-2" *ngIf="values?.isEditEvent" (click)="deleteEvent(dialog)">
        <img src="/assets/icons/delete.svg" alt="share-icon" class="cursor-pointer" height="20" width="20" />
      </button>
    </div>
  </ng-container>
</div>
<!-- dialogue for delete event  -->
<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="text-center">
        <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
        <br />

        <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Delete Event</label>
        <br />
        <label class="delete-lesson-plan-confirmation quicksand-bold-label">Are you sure want to delete this event ?</label>
      </div>
      <div class="d-flex">
        <button
          nbButton
          class="delete-lesson-plan bg-white bg-white-dark-mode m-2 w-100 quicksand-bold-label text-capitalize"
          (click)="ref.close()"
        >
          Cancel
        </button>
        <button
          style="
            border-radius: 8px;
            border: 1px solid var(--Error-600, #d92d20);
            background: var(--Error-600, #d92d20);

            /* Shadow/xs */
            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
          "
          nbButton
          class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label text-capitalize"
          (click)="deleteEvent()"
        >
          Delete
        </button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
